import React from 'react';

interface WizardStepsProps {
  etapaAtual: number;
  totalEtapas: number;
  etapas: string[];
}

export const WizardSteps: React.FC<WizardStepsProps> = ({
  etapaAtual,
  totalEtapas,
  etapas,
}) => {
  return (
    <div className="bg-white border-b border-gray-200 sticky top-0 z-10 shadow-sm">
      <div className="max-w-7xl mx-auto px-6 py-6">
        {/* Progress Bar */}
        <div className="mb-6">
          <div className="flex items-center justify-between mb-3">
            <span className="text-sm font-medium text-gray-700">
              Etapa {etapaAtual} de {totalEtapas}
            </span>
            <span className="text-sm font-semibold text-orange-600">
              {Math.round((etapaAtual / totalEtapas) * 100)}% concluído
            </span>
          </div>
          <div className="relative h-2 bg-gray-100 rounded-full overflow-hidden">
            <div
              className="absolute top-0 left-0 h-full bg-gradient-to-r from-orange-500 to-orange-600 rounded-full transition-all duration-500 ease-out shadow-sm"
              style={{ width: `${(etapaAtual / totalEtapas) * 100}%` }}
            >
              <div className="absolute inset-0 bg-white/20 animate-pulse"></div>
            </div>
          </div>
        </div>

        {/* Steps */}
        <div className="flex items-center justify-between relative">
          {/* Connection Line */}
          <div className="absolute top-5 left-0 right-0 h-0.5 bg-gray-200 -z-10"></div>
          <div
            className="absolute top-5 left-0 h-0.5 bg-gradient-to-r from-green-500 to-orange-500 -z-10 transition-all duration-500"
            style={{
              width: `${((etapaAtual - 1) / (totalEtapas - 1)) * 100}%`,
            }}
          ></div>

          {etapas.map((titulo, index) => {
            const stepNumber = index + 1;
            const isCompleted = stepNumber < etapaAtual;
            const isCurrent = stepNumber === etapaAtual;
            const isPending = stepNumber > etapaAtual;

            return (
              <div
                key={stepNumber}
                className="flex flex-col items-center relative"
                style={{ width: `${100 / totalEtapas}%` }}
              >
                {/* Step Circle */}
                <div
                  className={`
                    w-10 h-10 rounded-full flex items-center justify-center font-semibold text-sm
                    transition-all duration-300 relative z-10
                    ${
                      isCompleted
                        ? 'bg-gradient-to-br from-green-500 to-green-600 text-white shadow-lg shadow-green-500/30 scale-100'
                        : isCurrent
                        ? 'bg-gradient-to-br from-orange-500 to-orange-600 text-white shadow-lg shadow-orange-500/40 scale-110 ring-4 ring-orange-100'
                        : 'bg-white text-gray-400 border-2 border-gray-200'
                    }
                  `}
                >
                  {isCompleted ? (
                    <i className="ri-check-line text-lg"></i>
                  ) : (
                    <span>{stepNumber}</span>
                  )}
                  
                  {/* Pulse Animation for Current Step */}
                  {isCurrent && (
                    <span className="absolute inset-0 rounded-full bg-orange-400 animate-ping opacity-30"></span>
                  )}
                </div>

                {/* Step Title */}
                <span
                  className={`
                    mt-3 text-xs font-medium text-center transition-all duration-300 px-2
                    ${
                      isCompleted
                        ? 'text-green-700'
                        : isCurrent
                        ? 'text-orange-700 font-semibold'
                        : 'text-gray-400'
                    }
                  `}
                >
                  {titulo}
                </span>

                {/* Active Indicator */}
                {isCurrent && (
                  <div className="absolute -bottom-2 w-1 h-1 bg-orange-500 rounded-full animate-bounce"></div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};
